import { Modal, Button, Accordion, Card } from "react-bootstrap";
import React, { Component, useEffect, useState } from "react";
import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";

const VoiceCommand =(props)=> {
  const { voiceShowHide, handleVoiceShowHide } = props;
  const bgColor = "bg-admin-light border-admin-left";

  const[generalCommands, setGeneralCommands] = useState([
    {
      command: "Next",
      explanation: 'Say "next" to move the focus to the next element.',
    },
    {
      command: "Previous",
      explanation:
        'Say "previous" to move the focus to the previous element.',
    },
    {
      command: "Go",
      explanation:
        'Say "focus" and then the name of the text of the desired element (e.g.: "focus about us").',
    },
    {
      command: "Scroll",
      explanation:
        'Say "scroll" and then "down" or "up" (e.g.: "Scroll down").',
    },
    {
      command: "Click",
      explanation:
        'Say "click" to activate link or button that is focused.',
    },
    {
      command: "Input",
      explanation:
        'Say "input" and then the name of the form element to get the focus to (e.g.: "input first name").',
    },
    {
      command: "Pause",
      explanation:
        'Say "pause" to pause the voice recognition ("Muted" state).',
    },
    {
      command: "Stop",
      explanation: 'Say "stop" to turn off the Voice Commands function.',
    },
    {
      command: "Number",
      explanation:
        'Say "number" and the numbers value to focus on it, in "Smart Navigation" mode (e.g.: "number one").',
    },
  ]);
  const [accessbilityCommands, setAccessbilityCommands] = useState([
    {
      command: "Text Reader",
      explanation:
        'Say "turn / run / set text reader" to run the function.',
    },
    {
      command: "Keyboard Navigation",
      explanation:
        'Say "turn / run / set keyboard navigation" to run the function.',
    },
    {
      command: "Smart Navigation",
      explanation:
        'Say "turn / run / set smart navigation" to run the function.',
    },
    {
      command: "Screen Reader Adjustment",
      explanation:
        'Say "turn / run / set screen reader adjustment" to run the function.',
    },
    {
      command: "Contrast mode",
      explanation:
        'Say "turn / run / set contrast mode" to run the function.',
    },
    {
      command: "Bright High-Contrast",
      explanation:
        'Say "turn / run / set bright high-contrast" to run the function.',
    },
    {
      command: "Dark High-Contrast",
      explanation:
        'Say "turn / run / set dark high-contrast" to run the function.',
    },
    {
      command: "Blinks Blocking",
      explanation:
        'Say "turn / run / set blinks blocking" to run the function.',
    },
    {
      command: "Increase Font Size",
      explanation:
        'Say "turn / run / set increase font size" to run the function.',
    },
    {
      command: "Decrease Font Size",
      explanation:
        'Say "turn / run / set decrease font size" to run the function.',
    },
    {
      command: "Readable Font",
      explanation:
        'Say "turn / run / set readable font" to run the function.',
    },
    {
      command: "Large White Cursor",
      explanation:
        'Say "turn / run / set large white cursor" to run the function.',
    },
    {
      command: "Large Black Cursor",
      explanation:
        'Say "turn / run / set large black cursor" to run the function.',
    },
    {
      command: "Magnifier",
      explanation: 'Say "turn / run / set magnifier" to run the function.',
    },
    {
      command: "Highlights Links",
      explanation:
        'Say "turn / run / set highlights links" to run the function.',
    },
    {
      command: "Highlights Headers",
      explanation:
        'Say "turn / run / set highlights headers" to run the function.',
    },
    {
      command: "Image Descriptions",
      explanation:
        'Say "turn / run / set image descriptions" to run the function.',
    },
  ])
  const [dictionCommands, setDictionCommands] = useState([
    {
      command: "Delete",
      explanation:
        "Delete the last written word or the whole field content;",
    },
    {
      command: "New line",
      explanation: "Insert a new line (useful in textarea).",
    },
    {
      command: "Move the cursor position",
      explanation: "Move the focus to the start of the text element.",
    },
  ])
  const [punctuationCommands, setPunctuationCommands] = useState([
    {
      command: "Space ( )",
      explanation: "Say space",
    },
    {
      command: "Tab (	)",
      explanation: "Say tab",
    },
    {
      command: "New line ( )",
      explanation: "Say new line",
    },
    {
      command: '"And" sign (&)',
      explanation: "Say ampersand;and sign",
    },
    {
      command: "Period (.)",
      explanation: "Say period;point sign",
    },
    {
      command: "Ellipsis (…)",
      explanation: "Say ellipsis;dot dot dot",
    },
    {
      command: "Comma (,)",
      explanation: "Say comma",
    },
    {
      command: "Colon (:)",
      explanation: "Say colon",
    },
    {
      command: "Semi colon (;)",
      explanation: "Say semi colon",
    },
    {
      command: "Question mark (?)",
      explanation: "Say question mark",
    },
    {
      command: "Exclamation mark (!)",
      explanation: "Say exclamation point",
    },
    {
      command: "Equal sign (=)",
      explanation: "Say equal sign",
    },
    {
      command: "At sign (@)",
      explanation: "Say at sign",
    },
    {
      command: "Pipe sign (|)",
      explanation: "Say pipe sign",
    },
    {
      command: "Slash (/)",
      explanation: "Say forward slash",
    },
    {
      command: "Backslash ()",
      explanation: "Say backslash",
    },
    {
      command: "Hyphen (-)",
      explanation: "Say minus sign;hyphen",
    },
    {
      command: "Dash (—)",
      explanation: "Say dash",
    },
    {
      command: "Plus sign (+)",
      explanation: "Say plus sign",
    },
    {
      command: "Single quote (')",
      explanation: "Say single quote",
    },
    {
      command: 'Quotation mark (")',
      explanation: "Say Quotation mark;quotes",
    },
    {
      command: "Left parenthesis (()",
      explanation: "Say left parenthesis;open parenthesis",
    },
    {
      command: "Right parenthesis ())",
      explanation: "Say right parenthesis;close parenthesis",
    },
    {
      command: "Left bracket ([)",
      explanation: "Say left bracket / open bracket",
    },
    {
      command: "Right bracket (])",
      explanation: "Say right bracket;close bracket",
    },
    {
      command: "Left curly bracket ({)",
      explanation: "Say left curly bracket;open curly bracket",
    },
    {
      command: "Right curly bracket (})",
      explanation: "Say right curly bracket;close curly bracket",
    },
    {
      command: "Percent sign (%)",
      explanation: "Say percent sign",
    },
    {
      command: "Dollar sign ($)",
      explanation: "Say dollar sign",
    },
    {
      command: "Pound sign (#)",
      explanation: "Say pound sign;hash tag;number sign",
    },
    {
      command: "Apostrophe (`)",
      explanation: "Say apostrophe",
    },
    {
      command: "Degree sign (°)",
      explanation: "Say degree sign",
    },
    {
      command: "Tilde (~)",
      explanation: "Say tilde",
    },
    {
      command: "Caret (^)",
      explanation: "Say caret",
    },
    {
      command: "Asterisk (*)",
      explanation: "Say asterisk;star sign",
    },
    {
      command: "Smiling Face (😃)",
      explanation: "Say smiling Face",
    },
  ])
  const [voiceTest, setVoiceTest] = useState("")
  const [scrollPosition, setScrollPosition] = useState(0)
  const [selectedKey, setSelectedKey] = useState(-1)

  useEffect(()=>{
    SpeechRecognition.getRecognition().onresult = (event) => {
      let current = event.resultIndex;
      let transcript = event.results[current][0].transcript;
      console.log(transcript);
      setVoiceTest(transcript)
      handleSpeechCommand();
    };
  }, [])

  const handleSpeechStart = () => {
    SpeechRecognition.startListening({ continuous: true });
  };

  const handleSpeechStop = () => {
    SpeechRecognition.stopListening();
  };

  const handleSpeechReset = () => {
    setVoiceTest("")
  };

  const handleSpeechCommand = () => {
    if (voiceTest === "close popup" || voiceTest === " close popop") {
      handleVoiceShowHide();
    }

    if (voiceTest === "scroll down" || voiceTest === " scroll down") {
      handleScrollDown();
    }

    if (voiceTest === "scroll up" || voiceTest === " scroll up") {
      handleScrollUp();
    }
  };

  const handleScrollUp = () => {
    setScrollPosition(scrollPosition + 50)
    window.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  };

  const handleScrollDown = () => {
    console.log(scrollPosition);
    if (scrollPosition > 0) {
      setScrollPosition(scrollPosition - 50)
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    } else {
      setScrollPosition(0)
      window.scrollTo({
        top: scrollPosition,
        behavior: "smooth",
      });
    }
  };

  const handleSelect = (e) => {
    setSelectedKey(e)
  };

    return (
      <Modal
        show={voiceShowHide}
        size="lg"
        dialogClassName="modalLeftRight modalRight"
      >
        <Modal.Header closeButton onClick={handleVoiceShowHide}>
          <Modal.Title>Voice Command</Modal.Title>
        </Modal.Header>
        <Modal.Body className="bg-secondary">
          <div className="row">
            <div className="col-md-12 form-group">
              <input
                type="text"
                className="form-control"
                name="voiceTest"
                id="voiceTest"
                value={voiceTest}
              />
            </div>
            <div className="col-md-12 form-group text-center">
              <button
                className="btn btn-outline-default"
                onClick={handleSpeechStart}
              >
                Start
              </button>
              <button
                className="btn btn-outline-default"
                onClick={handleSpeechStop}
              >
                Stop
              </button>
              <button
                className="btn btn-outline-default"
                onClick={handleSpeechReset}
              >
                Reset
              </button>
            </div>

            <div className="col-md-12">
              <Accordion onSelect={handleSelect}>
                <Card className="shadow-none border">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="0"
                    className={`p-3 card-header1 ${bgColor}`}
                    aria-expanded={
                      selectedKey === "0" ? "true" : "false"
                    }
                  >
                    <h4 className="mb-0">General Commands</h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="0">
                    <div className="col-md-12 p-3">
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table align-items-center table-flush table-hover table-striped bg-white">
                            <thead className="thead-light">
                              <tr>
                                <th>Command</th>
                                <th>Explanation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {generalCommands.map((item) => (
                                <tr>
                                  <td>{item.command}</td>
                                  <td>{item.explanation}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
                <Card className="shadow-none border">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="1"
                    className={`p-3 card-header1 ${bgColor}`}
                    aria-expanded={
                      selectedKey === "1" ? "true" : "false"
                    }
                  >
                    <h4 className="mb-0">Web Accessibility Commands</h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="1">
                    <div className="col-md-12 p-3">
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table align-items-center table-flush table-hover table-striped bg-white">
                            <thead className="thead-light">
                              <tr>
                                <th>Command</th>
                                <th>Explanation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {accessbilityCommands.map((item) => (
                                <tr>
                                  <td>{item.command}</td>
                                  <td>{item.explanation}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
                <Card className="shadow-none border">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="2"
                    className={`p-3 card-header1 ${bgColor}`}
                    aria-expanded={
                      selectedKey === "2" ? "true" : "false"
                    }
                  >
                    <h4 className="mb-0">Dictation commands</h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="2">
                    <div className="col-md-12 p-3">
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table align-items-center table-flush table-hover table-striped bg-white">
                            <thead className="thead-light">
                              <tr>
                                <th>Command</th>
                                <th>Explanation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {dictionCommands.map((item) => (
                                <tr>
                                  <td>{item.command}</td>
                                  <td>{item.explanation}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
                <Card className="shadow-none border">
                  <Accordion.Toggle
                    as={Card.Header}
                    eventKey="3"
                    className={`p-3 card-header1 ${bgColor}`}
                    aria-expanded={
                      selectedKey === "3" ? "true" : "false"
                    }
                  >
                    <h4 className="mb-0">Punctuation marks</h4>
                  </Accordion.Toggle>
                  <Accordion.Collapse eventKey="3">
                    <div className="col-md-12 p-3">
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table align-items-center table-flush table-hover table-striped bg-white">
                            <thead className="thead-light">
                              <tr>
                                <th>Command</th>
                                <th>Explanation</th>
                              </tr>
                            </thead>
                            <tbody>
                              {punctuationCommands.map((item) => (
                                <tr>
                                  <td>{item.command}</td>
                                  <td>{item.explanation}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </Accordion.Collapse>
                </Card>
              </Accordion>
            </div>
          </div>
        </Modal.Body>
        {/* <Modal.Footer className="justify-content-center">
          <Button variant="danger" onClick={handleVoiceShowHide}>
            <i className="fa fa-times" aria-hidden="true"></i> Close
          </Button>
        </Modal.Footer> */}
      </Modal>
    );
  // }
}

export default VoiceCommand;
